/** The popper's distance from the trigger. The caret hangs into this gap, so its tip sits 8px clear. */
export const DEFAULT_OFFSET_PX = 12;
